// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contentful[data-v-34e7e990]{font-size:11px}.contentful button[data-v-34e7e990]{margin-right:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
